import { useNavigate } from "react-router-dom";
import NewAnnouncement from "./newannouncement";

function Announcement() {
  // const navigate = useNavigate();
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Platform  Announcement</div>
          <div>
          </div>
        </div>
        <NewAnnouncement />
      </div>
    </>
  );
}

export default Announcement;
